import React from 'react'

export default function Footer() {
    return (
        <div>
            <div className='row text-center my-5 m-auto'>
                <h2>Follow Player 2 Productions!</h2>
                <div className='d-flex justify-content-center'>
                    <a href='https://www.instagram.com/player2productionsindy/' target='_blank'><i class="fa-brands fa-instagram mx-5"></i></a>
                    <a href='https://www.facebook.com/Player2ProductionsIndy/' target='_blank'><i class="fa-brands fa-square-facebook mx-5"></i></a>
                </div>
            </div>
        </div>
    )
}
